export default "__VITE_ASSET__2adefcbc__"